/**
 * @module helper.array
 */
import { isArrayEmpty } from './isArrayEmpty';

/**
 * Insert items into specific index of source.
 * 
 * ```ts
 * insertIndex([1, 2, 3], 0, [4, 5]) => [4, 5, 1, 2, 3]
 * insertIndex([1, 2, 3], 1, [4, 5]) => [1, 4, 5, 2, 3]
 * insertIndex([1, 2, 3], 2, [4, 5]) => [1, 2, 4, 5, 3]
 * ```
 */
export function insertIndex<T>(source: T[], index: number, items: T[] = []): T[] {
	if (!Array.isArray(source)) {
		throw new Error('source should be array.');
	} else if (!Array.isArray(items)) {
		throw new Error('items should be array.');
	} else if (isArrayEmpty(items)) {
		return source;
	}

	const start = Math.min(index, source.length);

	return [
		...source.slice(0, start),
		...items,
		...source.slice(start, source.length),
	];
}
